import React, { createContext, useContext, useState } from 'react';

/**
 * Global state for Ask Swirl bottom bar
 * Persists input across all pages
 */
const AskSwirlContext = createContext();

export function AskSwirlProvider({ children }) {
  const [input, setInput] = useState('');

  const clearInput = () => setInput('');

  return (
    <AskSwirlContext.Provider value={{ input, setInput, clearInput }}>
      {children}
    </AskSwirlContext.Provider>
  );
}

export function useAskSwirlStore() {
  const context = useContext(AskSwirlContext);
  if (!context) {
    throw new Error('useAskSwirlStore must be used within AskSwirlProvider');
  }
  return context;
}

